import { AddNewTransactionMenuItem } from "./AddNewTransaction";
import { ImportCsvMenuItem } from "./ImportCsv";

export function HeaderMenuItem() {
  return <></>;
}

HeaderMenuItem.AddNewTransaction = AddNewTransactionMenuItem;
HeaderMenuItem.ImportCsv = ImportCsvMenuItem;
